import { render, staticRenderFns } from "./VibrationAlertSettings.vue?vue&type=template&id=240b2b6a&scoped=true"
import script from "./VibrationAlertSettings.vue?vue&type=script&lang=js"
export * from "./VibrationAlertSettings.vue?vue&type=script&lang=js"
import style0 from "./VibrationAlertSettings.vue?vue&type=style&index=0&id=240b2b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240b2b6a",
  null
  
)

export default component.exports